import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import apiRequest from '@utils/apiRequest'
import { decodeJwtPayload } from '@utils/jwtUtil'

// 알림톡 전송요청
export const sendSecond = createAsyncThunk('SEND_SECOND', async (data) => {
  let options = {
    method: 'POST',
    url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/auth/send-second`,
    data
  }
  let response = await apiRequest(options)
  if (response.__isError) { return }
  return response
})

// 로그인
export const login = createAsyncThunk('LOGIN', async (data) => {
  let options = {
    method: 'POST',
    url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/auth/login`,
    data
  }
  let response = await apiRequest(options)
  if (response.__isError) { return }
  return {
    data,
    response
  }
})

// 알림톡 인증
export const secondLogin = createAsyncThunk('SECOND_LOGIN', async (data) => {
  let options = {
    method: 'POST',
    url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/auth/second-login`,
    data
  }
  let response = await apiRequest(options)
  if (response.__isError) { return }
  return response
})

// 로그아웃
export const logout = createAsyncThunk('LOGOUT', async () => {
  let options = {
    method: 'POST',
    url: `${process.env.REACT_APP_AP_CLIENT_SERVER_HOST}/auth/logout`,
  }
  let response = await apiRequest(options)
  if (response.__isError) { return }
  return response
})

const userSlice = createSlice({
  name: 'user',
  initialState: {
    isLoading: false,
    isSuccess: false,
    accessToken: null,
    refreshToken: null,
    user: {},
    tempUser: {}
  },
  reducers: {
    getToken (state) {
      const token = localStorage.getItem('accessToken')

      if (token) {
        const jwtPayload = decodeJwtPayload(token)

        state.user = {
          id: jwtPayload.sub,
          roles: jwtPayload.auth.split(",")
        }
        state.accessToken = token
      }
    },
    clearIsSuccess: (state) => {
      state.isSuccess = false
    },
    clearIsLoading: (state) => {
      state.isLoading = false
    }
  },
  extraReducers: {
    [login.pending]: (state) => {
      state.isLoading = true
    },
    [login.rejected]: (state) => {
      state.isLoading = false
    },
    [login.fulfilled]: (state, { payload }) => {
      state.isLoading = false

      if (!payload?.response) {
        return
      }

      if (payload.response.grantType === '2factor') {
        state.tempUser = {
          userId: payload.data.userId,
          password: payload.data.password,
        }

        state.isSuccess = true

        return
      }

      const { accessToken, refreshToken } = payload.response
      const jwtPayload = decodeJwtPayload(accessToken)

      localStorage.setItem('accessToken', accessToken)
      localStorage.setItem('refreshToken', refreshToken)

      state.user = {
        id: jwtPayload.sub,
        roles: jwtPayload.auth.split(",")
      }
      state.accessToken = accessToken
    },
    [sendSecond.pending]: (state) => {
    },
    [sendSecond.rejected]: (state) => {
    },
    [sendSecond.fulfilled]: (state, { payload }) => {
      if (!payload) {
        state.isSuccess = false
      }
    },
    [secondLogin.pending]: (state) => {
      state.isLoading = true
    },
    [secondLogin.rejected]: (state) => {
      state.isLoading = false
    },
    [secondLogin.fulfilled]: (state, { payload }) => {
      state.isLoading = false

      if (!payload) {
        return
      }

      const { accessToken, refreshToken } = payload
      const jwtPayload = decodeJwtPayload(accessToken)

      localStorage.setItem('accessToken', accessToken)
      localStorage.setItem('refreshToken', refreshToken)

      state.user = {
        id: jwtPayload.sub,
        roles: jwtPayload.auth.split(",")
      }
      state.accessToken = accessToken

      state.isSuccess = false
    },
    [logout.rejected]: (state) => {
      state.accessToken = null
      state.user = {}

      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
    },
    [logout.fulfilled]: (state, { payload }) => {
      state.accessToken = null
      state.user = {}

      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
    }
  }
})

export const { getToken, clearIsSuccess, clearIsLoading } = userSlice.actions

export default userSlice.reducer
